import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AddHospitalizationService } from './add-hospitalization.service';
import { MasterService } from 'src/app/masters/master.service';
import * as CommonConstants from '../../../utils/common.constants';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from 'src/app/utils/shared.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import swal from 'sweetalert2';
import { LoaderService } from 'src/app/common/loader.service';
import * as moment from 'moment';

@Component({
  selector: 'app-add-hospitalization',
  templateUrl: './add-hospitalization.component.html',
  styleUrls: ['./add-hospitalization.component.scss']
})
export class AddHospitalizationComponent implements OnInit {
  details;
  medhpId;
  today = new Date();

  //Master list
  yesNo = [{ id: 'Yes', value: 'Yes' }, { id: 'No', value: 'No' }]
  partnerList = [];
  reasons;
  procNames;
  emergency;
  specialities;
  specialistList;
  hospitals;
  address;
  roomType;
  bedType;
  status;
  patientConditions;
  subjectiveSigns;
  objectiveSigns;
  surgeryTransferTos;
  surgeryOpinions;
  transferPlaces;
  reportWays;


  planForm: FormGroup;
  admissionForm: FormGroup;
  examAdmissionForm: FormGroup;
  reportOpRoomForm: FormGroup;
  opReportForm: FormGroup;
  hospReportForm: FormGroup;
  medicalReportForm: FormGroup;

  procList = [];

  SERVICES = ['MED_HOSP_HOSPITALIZATION', 'MED_HOSP_ADMISSION_EXAM', 'MED_HOSP_ADMISSION', 'MED_HSOP_MEDICAL_REPORT', 'MED_HOSP_REPORT', 'MED_HOSP_SURGERY', 'MED_HOSP_SURGERY_REPORT'];


  constructor(private service: AddHospitalizationService, private modal: NgbModal,
    private route: ActivatedRoute, private masterService: MasterService, private fb: FormBuilder,
    private router: Router, private sharedService: SharedService, private loader: LoaderService) {

    this.details = this.router.getCurrentNavigation().extras.state.details;
    this.medhpId = this.details.medhpId;

  }

  back() {
    this.sharedService.nextMedicalFiledId(this.details['medicalFileDtls']['medfiId']);
    this.sharedService.medicalFileStatus(this.details['medicalFileDtls']['status']);
    localStorage.setItem(CommonConstants.FILE_STATUS, this.details['medicalFileDtls']['status']);
    this.router.navigate(["/addMedicalFiles"], {
      state: {
        medicalFileDtls: this.details['medicalFileDtls']
      }
    });
  }

  openGridModal(modalId) {
    this.modal.open(modalId, { container: '.page-content' });
  }

  addProcProvided(date, desc) {
    this.procList.push({ date: date, desc: desc })
    this.modal.dismissAll();
  }

  loadMaster() {
    let masterData = this.route.snapshot.data.masterData;
    if (masterData) {
      this.reasons = masterData.reasons;
      this.procNames = masterData.procNames;
      this.emergency = masterData.emergency;
      this.roomType = masterData.roomType;
      this.bedType = masterData.bedType;
      this.status = masterData.status;
      this.patientConditions = masterData.patientConditions;
      this.subjectiveSigns = masterData.subjectiveSigns;
      this.objectiveSigns = masterData.objectiveSigns;
      this.surgeryTransferTos = masterData.surgeryTransferTos;
      this.surgeryOpinions = masterData.surgeryOpinions;
      this.transferPlaces = masterData.transferPlaces;
      this.reportWays = masterData.reportWays;
      this.specialities = masterData.specialities;
    }

    setTimeout(() => {
      this.masterService.partnerList.subscribe(value => {
        this.partnerList = value;
        this.setPartners();
      })
    }, 500);

  }

  setPartners() {
    this.specialistList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_PRACTITIONER_TYPE);
    this.hospitals = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_HOSPITAL_TYPE);
  }

  ngOnInit() {
    this.loader.display(false)
    this.loadMaster();


    this.planForm = this.fb.group({
      medhpId: [this.medhpId],
      bedType: [''],
      exitdate: [''],
      hospiId: [this.details.hospiId],
      medfiId: [this.details.medfiId],
      medhpBlExtraBed: [false],
      medhpDtEnter: [''],
      medhpDtPlanDate: [''],
      medhpPreDuration: [''],
      medhpPreNote: [''],
      medhpPreProvworkstoppage: [''],
      medhpPreRecomCons: [''],
      medhpPreReturnFliSche: [''],
      medhpVaAcceptedBy: [''],
      medhpVaOtherExtra: [''],
      medhpVaPlanBy: [''],
      medhpVaPlanComment: [''],
      medhpVaProcedureDesc: [''],
      patcoId: [null],
      planEmergency: [''],
      planProcedure: [''],
      planReason: [''],
      planType: [''],
      pradrId: [null],
      prtieId: [null],
      rotypId: [null],
      spltyId: [null],
      staRecCode: ['A'],
      statuCode: ['']
    });

    this.admissionForm = this.fb.group({
      medhpId: [this.medhpId],
      bedTypeAdmiss: [''],
      medhpDtAdmissionDate: [''],
      medhpVaAdmissionComment: [''],
      medhpVaAdmissionDoctor: [''],
      medhpVaAdmissionFloor: [''],
      medhpVaAdmissionReceptionNurse: [''],
      medhpVaAdmissionRoom: [''],
      medhpVaAdmissionTel: [''],
      medhpVaAdmissionTelNurse: [''],
      medhpVaAdmissionTelPatient: [''],
      medhpVaAdmissionUnit: [''],
      medhpVaCode: [''],
      spltyIdAdmiss: [null],
      staRecCode: ['A']
    });

    this.examAdmissionForm = this.fb.group({
      envExtPlId: [''],
      envTraId: [''],
      envTraStopWorkingAgain: [''],
      medhpDtExamAdmissionDate: [''],
      medhpDtExamAdmissionDurationDate: [''],
      medhpDtExamAdmissionExit: [''],
      medhpId: [this.medhpId],
      medhpNuExamAdmissionDuration: [],
      medhpVaExamAdmissionBloodPressure: [''],
      medhpVaExamAdmissionComment: [''],
      medhpVaExamAdmissionSubj: [[]],
      medhpVaExamAdmissionObj: [[]],
      medhpVaExamAdmissionDiagnostic: [''],
      medhpVaExamAdmissionDiagnosticEntry: [''],
      medhpVaExamAdmissionDoctor: [''],
      medhpVaExamAdmissionExam: [''],
      medhpVaExamAdmissionHeight: [''],
      medhpVaExamAdmissionIma: [''],
      medhpVaExamAdmissionPulse: [''],
      medhpVaExamAdmissionService: [''],
      medhpVaExamAdmissionTemperature: [''],
      medhpVaExamAdmissionWeight: [''],
      patcoIdExamAdmission: [null],
      staRecCode: ['A'],
      procList: []
    })

    this.reportOpRoomForm = this.fb.group({
      medhpId: [this.medhpId],
      medhpOperaAids: [''],
      medhpOperaAnesthetist: [''],
      medhpOperaBlockouttime: [''],
      medhpOperaByairplaneexitplanned: [''],
      medhpOperaDateandhour: [''],
      medhpOperaDestinationplanned: [''],
      medhpOperaEndtime: [''],
      medhpOperaExitplanned: [''],
      medhpOperaNote: [''],
      medhpOperaNurseroom: [''],
      medhpOperaOperator: [''],
      medhpOperaPerformedbycro: [''],
      medhpOperaPreopdiagnosis: [''],
      medhpOperaRecord: [''],
      medhpOperaStarttime: [''],
      medhpOperaSurgicaldiagnosis: [''],
      medhpOperaTransferto: [''],
      staRecCode: ['A']
    });

    this.medicalReportForm = this.fb.group({
      medhpDtReportDate: [''],
      medhpDtReportExitDatetime: [''],
      medhpId: [this.medhpId],
      medhpVaReportBmi: [''],
      medhpVaReportBp: [''],
      medhpVaReportComment: [''],
      medhpVaReportDoctor: [''],
      medhpVaReportEntry: [''],
      medhpVaReportEntryDiagnostic: [''],
      medhpVaReportImmediateResult: [''],
      medhpVaReportPouls: [''],
      medhpVaReportProcedureDone: [''],
      medhpVaReportSize: [''],
      medhpVaReportTemp: [''],
      medhpVaReportWeight: [''],
      reportDestination: [''],
      reportWay: [''],
      staRecCode: ['A'],
      patCoId: [null]
    });

    this.opReportForm = this.fb.group({
      medhpDtOpeReport: [''],
      medhpDtOpeReportBlocOutTime: [''],
      medhpDtOpeReportEnd: [''],
      medhpDtOpeReportExpectedExit: [''],
      medhpDtOpeReportExpectedTurnBack: [''],
      medhpDtOpeReportStart: [''],
      medhpId: [this.medhpId],
      medhpVaOpeReport: [''],
      medhpVaOpeReportAnesthetist: [''],
      medhpVaOpeReportAssistance: [''],
      medhpVaOpeReportDiagnostic: [''],
      medhpVaOpeReportExpectedDestination: [''],
      medhpVaOpeReportNurseRoom: [''],
      medhpVaOpeReportOperator: [''],
      opeRepOpiId: [''],
      staRecCode: ['A'],
      transferTo: ['']
    });

    this.hospReportForm = this.fb.group({
      medhpDtHospReportDate: [''],
      medhpDtHospReportEffectiveExitdate: [''],
      medhpDtHospReportIntialExitDate: [''],
      medhpDtHospReportNextAppointmentDate: [''],
      medhpEnHospReportInitialDestination: [''],
      medhpEnHospReportReportDestination: [''],
      medhpId: [this.medhpId],
      medhpVaHospReportAppointmentWithDoctor: [''],
      medhpVaHospReportBloodpressure: [''],
      medhpVaHospReportDoctor: [''],
      medhpVaHospReportExam: [''],
      medhpVaHospReportFinalDiagnostic: [''],
      medhpVaHospReportHeight: [''],
      medhpVaHospReportIma: [''],
      medhpVaHospReportPulse: [''],
      medhpVaHospReportReport: [''],
      medhpVaHospReportService: [''],
      medhpVaHospReportTemperature: [''],
      medhpVaHospReportWeight: [''],
      patcoIdHospReport: [''],
      staRecCode: ['A'],
      medhpVaHospReportEntryDiagnostic: [''],
      procList: []

    });

    if (this.medhpId) {   //Only for existing record. Will not load for 'Add New'
      this.loadData();
    }
  }

  loadData() {
    this.service.getFileData(this.medhpId, this.SERVICES).subscribe(res => {
    // })

    // this.service.getHardCodedData().subscribe(res => {
      if (res['code'] === 'S0000') {
        const result = res['result'];
        // this.patchForm(this.planForm, result['']);
        this.patchForm(this.admissionForm, result['MED_HOSP_ADMISSION']);
        this.patchForm(this.opReportForm, result['MED_HOSP_SURGERY']);
        this.patchForm(this.hospReportForm, result['MED_HOSP_REPORT']);
        this.patchForm(this.examAdmissionForm, result['MED_HOSP_ADMISSION_EXAM']);
        this.patchForm(this.medicalReportForm, result['MED_HSOP_MEDICAL_REPORT']);
        this.patchForm(this.reportOpRoomForm, result['MED_HOSP_SURGERY_REPORT']);
      }
    })
  }

  patchForm(formGroup: FormGroup, data) {
    if (data.length > 0) {
      formGroup.patchValue(data[0]);
    }
  }

  savePlan() {
    let data = {
      ...this.planForm.value,
      medhpDtEnter: this.planForm.value.medhpDtEnter ? moment(this.planForm.value.medhpDtEnter).format("DD-MM-YYYY HH:mm") : '',
      exitdate: this.planForm.value.exitdate ? moment(this.planForm.value.exitdate).format("DD-MM-YYYY HH:mm") : '',
      medhpDtPlanDate:  this.planForm.value.medhpDtPlanDate ? moment(this.planForm.value.medhpDtPlanDate).format("DD-MM-YYYY HH:mm") : ''
    }
    this.service.savePlan(data).subscribe(res => {
      if (res['code'] === '0') {
        swal.fire("Saved successfully", '', 'success');
        this.planForm.patchValue(res['result'])
      }
    })
  }

  saveAdmission() {
    let data = {
      ...this.admissionForm.value,
      medhpDtAdmissionDate: this.admissionForm.value.medhpDtAdmissionDate ? moment(this.admissionForm.value.medhpDtAdmissionDate).format("DD-MM-YYYY HH:mm") : '',
    }
    this.service.saveAdmission(data).subscribe(res => {
      if (res['code'] === '0') {
        swal.fire("Saved successfully", '', 'success');
        this.admissionForm.patchValue(res['result'])
      }
    })

  }

  saveExamAdmission() {
    let data = {
      ...this.examAdmissionForm.value,
      medhpDtExamAdmissionDate: this.examAdmissionForm.value.medhpDtExamAdmissionDate ? moment(this.examAdmissionForm.value.medhpDtExamAdmissionDate).format("DD-MM-YYYY HH:mm") : '',
      medhpDtExamAdmissionDurationDate: this.examAdmissionForm.value.medhpDtExamAdmissionDurationDate ? moment(this.examAdmissionForm.value.medhpDtExamAdmissionDurationDate).format("DD-MM-YYYY HH:mm") : '',
      medhpDtExamAdmissionExit: this.examAdmissionForm.value.medhpDtExamAdmissionExit ? moment(this.examAdmissionForm.value.medhpDtExamAdmissionExit).format("DD-MM-YYYY HH:mm") : ''

    }
    this.service.saveExamAdmission(data).subscribe(res => {
      if (res['code'] === '0') {
        swal.fire("Saved successfully", '', 'success');
        this.examAdmissionForm.patchValue(res['result'])
      }
    })
  }

  saveOperatingRoom() {
    let data = {
      ...this.reportOpRoomForm.value,
      medhpOperaDateandhour: this.reportOpRoomForm.value.medhpDtExamAdmissionDate ? moment(this.reportOpRoomForm.value.medhpDtExamAdmissionDate).format("DD-MM-YYYY HH:mm") : '',
      medhpOperaEndtime:  this.reportOpRoomForm.value.medhpOperaEndtime ? moment(this.reportOpRoomForm.value.medhpOperaEndtime).format("DD-MM-YYYY HH:mm") : '',
      medhpOperaStarttime:  this.reportOpRoomForm.value.medhpOperaStarttime ? moment(this.reportOpRoomForm.value.medhpOperaStarttime).format("DD-MM-YYYY HH:mm") : ''
    }
    
    this.service.saveOperatingRoom(data).subscribe(res => {
      if (res['code'] === '0') {
        swal.fire("Saved successfully", '', 'success');
        this.reportOpRoomForm.patchValue(res['result'])
      }
    })
  }

  saveOperativeReport() {
    let data = {
      ...this.opReportForm.value,
      medhpDtOpeReport: this.opReportForm.value.medhpDtOpeReport ? moment(this.opReportForm.value.medhpDtOpeReport).format("DD-MM-YYYY HH:mm") : '',
      medhpDtOpeReportBlocOutTime: this.opReportForm.value.medhpDtOpeReportBlocOutTime ? moment(this.opReportForm.value.medhpDtOpeReportBlocOutTime).format("DD-MM-YYYY HH:mm") : '',
      medhpDtOpeReportStart: this.opReportForm.value.medhpDtOpeReportStart ? moment(this.opReportForm.value.medhpDtOpeReportStart).format("DD-MM-YYYY HH:mm") : '',
      medhpDtOpeReportEnd: this.opReportForm.value.medhpDtOpeReportEnd ? moment(this.opReportForm.value.medhpDtOpeReportEnd).format("DD-MM-YYYY HH:mm") : '',
      medhpDtOpeReportExpectedTurnBack:  this.opReportForm.value.medhpDtOpeReportExpectedTurnBack ? moment(this.opReportForm.value.medhpDtOpeReportExpectedTurnBack).format("DD-MM-YYYY HH:mm") : '',
      medhpDtOpeReportExpectedExit:  this.opReportForm.value.medhpDtOpeReportExpectedExit ? moment(this.opReportForm.value.medhpDtOpeReportExpectedExit).format("DD-MM-YYYY HH:mm") : ''
    }
    this.service.saveOperativeReport(data).subscribe(res => {
      if (res['code'] === '0') {
        swal.fire("Saved successfully", '', 'success');
        this.opReportForm.patchValue(res['result'])
      }
    })
  }

  saveHospReport() {
    let data = {
      ...this.hospReportForm.value,
      medhpDtHospReportDate: this.hospReportForm.value.medhpDtHospReportDate ? moment(this.hospReportForm.value.medhpDtHospReportDate).format("DD-MM-YYYY HH:mm") : '',
      medhpDtHospReportEffectiveExitdate: this.hospReportForm.value.medhpDtHospReportEffectiveExitdate ? moment(this.hospReportForm.value.medhpDtHospReportEffectiveExitdate).format("DD-MM-YYYY HH:mm") : '',
      medhpDtHospReportIntialExitDate: this.hospReportForm.value.medhpDtHospReportIntialExitDate ? moment(this.hospReportForm.value.medhpDtHospReportIntialExitDate).format("DD-MM-YYYY HH:mm") : '',
      medhpDtHospReportNextAppointmentDate: this.hospReportForm.value.medhpDtHospReportNextAppointmentDate ? moment(this.hospReportForm.value.medhpDtHospReportNextAppointmentDate).format("DD-MM-YYYY HH:mm") : ''
    }
    this.service.saveHospReport(data).subscribe(res => {
      if (res['code'] === '0') {
        swal.fire("Saved successfully", '', 'success');
        this.hospReportForm.patchValue(res['result'])
      }
    })
  }

  saveMedicalReport() {
    let data = {
      ...this.medicalReportForm.value,
      medhpDtReportDate: this.medicalReportForm.value.medhpDtReportDate ? moment(this.medicalReportForm.value.medhpDtReportDate).format("DD-MM-YYYY HH:mm") : '',
      medhpDtReportExitDatetime: this.medicalReportForm.value.medhpDtReportExitDatetime ? moment(this.medicalReportForm.value.medhpDtReportExitDatetime).format("DD-MM-YYYY HH:mm") : ''
    }
    this.service.saveMedicalReport(data).subscribe(res => {
      if (res['code'] === '0') {
        swal.fire("Saved successfully", '', 'success');
        this.medicalReportForm.patchValue(res['result'])
      }
    })
  }

}
